<template>
	<div>
		<v-navigation-drawer v-model="navState" fixed :clipped="$vuetify.breakpoint.lgAndUp" app v-if="items && this.getPermissions.modules && !getLicenseExpired">
			<v-list dense>
				<template v-if="getRollback && getRollback.email">
					<v-list-item style="cursor: pointer; height: 15px; min-height: 15px">
						<v-list-item-title>
							<small @click="executeRollback">Ritorna ad {{ getRollback.name }}</small>
						</v-list-item-title>
					</v-list-item>
				</template>

				<v-list-item to="/" style="cursor: pointer; height: 20px; min-height: 20px; margin-bottom: 10px">
					<v-list-item-content>
						<v-list-item-title>Ciao {{ getName }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item to="/home" link>
					<v-list-item-icon>
						<v-icon>mdi-view-dashboard-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Dashboard</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-group v-for="item in items" v-if="(getRole === 0 || checkPermissions(item.module)) && item.model" :key="item.text" v-model="item.active" :prepend-icon="item.icon" no-action>
					<template #activator>
						<v-list-item-content>
							<v-list-item-title v-text="item.text" />
						</v-list-item-content>
					</template>

					<v-list-item v-for="subItem in item.items" v-if="(getRole === 0 || checkPermissions(subItem.module)) && (!subItem.soloAdmin || isAdminSession)" :key="subItem.text" :to="subItem.path" :exact="!!subItem.exact" link>
						<v-list-item-icon v-if="subItem.icon">
							<v-icon>{{ subItem.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title :to="subItem.path" v-text="subItem.text" />
						</v-list-item-content>
					</v-list-item>
				</v-list-group>
				<v-list-item to="/tickets">
					<v-list-item-icon>
						<v-icon>mdi-ticket-confirmation-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Ticket</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item to="/profile">
					<v-list-item-icon>
						<v-icon>mdi-account</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Profilo</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<!--
					Su telefono il Logout sta qui dentro, nella lista che scorre, e non
					solo nel piede del cassetto: il piede e' ancorato al fondo di un
					elemento alto quanto la finestra, e sui browser mobili la barra degli
					indirizzi copre proprio quella fascia. Il pulsante c'era ma finiva
					fuori dallo schermo, senza modo di raggiungerlo.
				-->
				<v-list-item v-if="$vuetify.breakpoint.smAndDown" @click="logout">
					<v-list-item-icon>
						<v-icon>mdi-logout</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Logout</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>

			<template #append>
				<div class="pl-2 pr-2">
					<small style="font-size: 10px; font-weight: bold">v. {{ getVersion }} {{ getNodeEnv }}</small>
				</div>
				<!-- Su telefono il Logout e' gia' in fondo alla lista: qui sarebbe un doppione. -->
				<div class="pa-2" v-if="!$vuetify.breakpoint.smAndDown">
					<v-btn class="primary" block @click="logout"> Logout </v-btn>
				</div>
			</template>
		</v-navigation-drawer>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
	data() {
		return {
			items: [
				{
					module: 'pre-order',
					icon: 'mdi-package-up',
					text: this.$vuetify.lang.t('$vuetify.front.preOrder'),
					model: true,

					items: [
						{ text: this.$vuetify.lang.t('$vuetify.front.attributes'), path: '/attributes', module: 'pre-order.attributes' },
						{ text: this.$vuetify.lang.t('$vuetify.front.variants'), path: '/variants', module: 'pre-order.variants' },
						{ text: this.$vuetify.lang.t('$vuetify.front.categories'), path: '/categories', module: 'pre-order.categories' },
						{ text: this.$vuetify.lang.t('$vuetify.front.brands'), path: '/brands', module: 'pre-order.brands' },
						{ text: 'Import da marchi', path: '/brand-import', module: 'pre-order.brandimport' },
						{ text: 'Competitor', path: '/competitor', module: 'pre-order.competitor' },
						{ text: this.$vuetify.lang.t('$vuetify.front.tags'), path: '/tags', module: 'pre-order.tags' },
						{ text: this.$vuetify.lang.t('$vuetify.front.suppliers'), path: '/suppliers', module: 'pre-order.suppliers' },
						{ text: this.$vuetify.lang.t('$vuetify.front.items.items'), path: '/items', module: 'pre-order.items' },
						// prodotti attivi con dati mancanti o sbagliati: stesso permesso della lista prodotti
						{ text: 'Controllo catalogo', path: '/catalog-check', module: 'pre-order.items' },
						/*{ text: this.$vuetify.lang.t('$vuetify.front.inventory'), path: '/inventories', module: 'pre-order.inventories' },*/
						{ text: this.$vuetify.lang.t('$vuetify.front.bought'), path: '/bought', module: 'pre-order.boughts' },
						{ text: this.$vuetify.lang.t('$vuetify.front.cartadandoned'), path: '/cartabandoned', module: 'pre-order.carrelloabbandonato' },
						{ text: 'Volantini', path: '/flyers', module: 'pre-order.flyers' },
						{ text: 'Piano social', path: '/social-posts', module: 'pre-order.socialposts' },
						{ text: 'Consigli', path: '/insights', module: 'pre-order.insights' },
					],
				},
				{
					module: 'post-order',
					icon: 'mdi-calendar-clock',
					text: this.$vuetify.lang.t('$vuetify.front.postOrder'),
					model: true,
					items: [
						{ text: this.$vuetify.lang.t('$vuetify.front.listOrder'), path: '/orders', module: 'post-order.orders' },
						{ text: 'Board ordini', path: '/orders-board', module: 'post-order.orders' },
						{ text: this.$vuetify.lang.t('$vuetify.front.packingList'), path: '/packing-list', module: 'post-order.packinglist' },
						{ text: 'Smistamento Ordini', path: '/dispatch-orders', module: 'post-order.dispatch-orders' },
						{ text: this.$vuetify.lang.t('$vuetify.front.listOrderSuppliers'), path: '/order-suppliers', module: 'post-order.order_suppliers' },
						{ text: this.$vuetify.lang.t('$vuetify.front.listCustomer'), path: '/customers', module: 'post-order.customers' },
						{ text: this.$vuetify.lang.t('$vuetify.front.listShipping'), path: '/shippings', module: 'post-order.shippings' },
						{ text: this.$vuetify.lang.t('$vuetify.front.monitorShipping'), path: '/monitor-shippings', module: 'post-order.shippings' },
						{ text: this.$vuetify.lang.t('$vuetify.front.notifiche.notifiche'), path: '/notify', module: 'post-order.notify' },
						{ text: this.$vuetify.lang.t('$vuetify.front.newsletters'), path: '/newsletters', module: 'post-order.newsletters' },
						{ text: this.$vuetify.lang.t('$vuetify.front.returns'), path: '/returns', module: 'post-order.returns' },
						{ text: this.$vuetify.lang.t('$vuetify.front.stats'), path: '/stats', module: 'post-order.stats' },
						{ text: 'Gift Card', path: '/gift-card', module: 'ecommerce.wallet' },
					],
				},
				{
					module: 'post-order',
					icon: 'mdi-finance',
					text: 'Report',
					model: true,
					// ordine voluto, non alfabetico (vedi l'ordinamento in mounted)
					keepOrder: true,
					items: [
						{ text: 'Commissioni', path: '/finance/fees', module: 'post-order.finance' },
						{ text: 'Costi manuali', path: '/finance/costs', module: 'post-order.finance' },
						// exact: /finance e' l'inizio di tutti gli indirizzi della sezione, senza resterebbe sempre attiva
						{ text: 'Report finanziario', path: '/finance', module: 'post-order.finance', exact: true },
						{ text: 'Report clienti', path: '/finance/customers', module: 'post-order.finance' },
						{ text: 'Report scorte', path: '/finance/inventory', module: 'post-order.finance' },
						{ text: 'IVA estera e OSS', path: '/finance/foreign', module: 'post-order.finance' },
						{ text: 'Pubblicità', path: '/ads', module: 'post-order.finance' },
					],
				},
				{
					module: 'post-order.affiliate',
					icon: 'mdi-image-filter-center-focus-strong-outline ',
					text: this.$vuetify.lang.t('$vuetify.front.affiliate.affiliate'),
					model: true,
					items: [
						{ text: this.$vuetify.lang.t('$vuetify.front.affiliate.marketing'), path: '/affiliate/marketing', module: 'post-order.affiliate' },
						{ text: this.$vuetify.lang.t('$vuetify.front.affiliate.partner'), path: '/affiliate/partner', module: 'post-order.affiliate' },
						{ text: 'Dashboard', path: '/affiliate/dashboard', module: 'post-order.affiliate' },
					],
				},
				{
					module: 'warehouse',
					icon: 'mdi-barcode-scan',
					model: true,
					text: this.$vuetify.lang.t('$vuetify.front.warehouse.home'),
					items: [
						{ text: this.$vuetify.lang.t('$vuetify.front.warehouse.detail'), path: '/warehouse/detail', module: 'warehouse.detail' },
						{ text: this.$vuetify.lang.t('$vuetify.front.warehouse.incoming'), path: '/warehouse/incoming', module: 'warehouse.incoming' },
						{ text: this.$vuetify.lang.t('$vuetify.front.warehouse.outcoming'), path: '/warehouse/outcoming', module: 'warehouse.outcoming' },
						{ text: this.$vuetify.lang.t('$vuetify.front.warehouse.inventory'), path: '/warehouse/inventory', module: 'warehouse.inventory' },
						{ text: this.$vuetify.lang.t('$vuetify.front.warehouse.ddt'), path: '/warehouse/ddt', module: 'warehouse.ddt' },
						{ text: this.$vuetify.lang.t('$vuetify.front.warehouse.cashout'), path: '/warehouse/cashout', module: 'warehouse.cashout' },
					],
				},
				{
					module: 'ecommerce',
					icon: 'mdi-web',
					model: false,
					text: this.$vuetify.lang.t('$vuetify.front.ecommerce.home'),
					items: [
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.pages'), path: '/ecommerce/pages', module: 'ecommerce.pages' },
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.themeSettings'), path: '/ecommerce/layout', module: 'ecommerce.layout' },
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.categoriesevidence'), path: '/ecommerce/highlightedcategories', module: 'ecommerce.layout' },
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.shipmentmethod'), path: '/ecommerce/shipmentmethod', module: 'ecommerce.shipmentmethod' },
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.shipmentcost'), path: '/ecommerce/shipmentcost', module: 'ecommerce.shipmentcost' },
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.emailtemplate'), path: '/ecommerce/emailtemplate', module: 'ecommerce.emailtemplate' },
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.authentication'), path: '/ecommerce/authentication', module: 'ecommerce.authentication' },
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.coupon'), path: '/ecommerce/coupon', module: 'ecommerce.coupon' },
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.offers'), path: '/ecommerce/offers', module: 'ecommerce.offers' },
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.blog'), path: '/ecommerce/blogs', module: 'ecommerce.blogs' },
						// richieste dei clienti del sito: avvisami quando torna disponibile / se il prezzo scende
						{ text: 'Avvisi', path: '/ecommerce/alerts', module: 'ecommerce.alerts' },
						// recensioni lasciate dai clienti sul sito, di tutti i prodotti; permesso della sezione
						{ text: 'Recensioni', path: '/ecommerce/reviews', module: 'ecommerce' },
						// URL del sito pubblico non trovati (404) e redirect dai vecchi indirizzi; permesso della sezione
						{ text: 'Redirect', path: '/ecommerce/redirects', module: 'ecommerce' },
						// cosa cercano i visitatori nel sito e cosa non trovano; permesso della sezione
						{ text: 'Ricerche sul sito', path: '/ecommerce/searches', module: 'ecommerce' },
						// scansione del sito pubblico (link rotti, redirect, title, sitemap...); permesso della sezione
						{ text: 'Salute del sito', path: '/ecommerce/site-health', module: 'ecommerce' },
						// velocita' del sito misurata sui visitatori veri (Core Web Vitals): solo per lo staff, perche'
						// quasi sempre dipende dal codice dell'ecommerce e non dal merchant (blocco anche nella rotta)
						{ text: 'Velocità del sito', path: '/ecommerce/speed', module: 'ecommerce', soloAdmin: true },
						{ text: 'Salute del server', path: '/ecommerce/server-health', module: 'ecommerce', soloAdmin: true },
						// permesso della sezione: nessun modulo nuovo da abilitare su profili e ruoli
						// le richieste premi si aprono da dentro la scheda a punti
						{ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.loyalty'), path: '/ecommerce/loyalty', module: 'ecommerce' },
					],
				},
				{
					module: 'agents',
					icon: 'mdi-briefcase-account',
					text: this.$vuetify.lang.t('$vuetify.front.agents.items'),
					model: true,
					items: [
						{ text: this.$vuetify.lang.t('$vuetify.front.agents.list'), path: '/agents', module: 'agents.list' },
						{ text: this.$vuetify.lang.t('$vuetify.front.listOrderAgents'), path: '/agents-order', module: 'agents.orders' },
					],
				},
				{
					module: 'employee',
					icon: 'mdi-account-supervisor-circle',
					text: this.$vuetify.lang.t('$vuetify.front.employee.items'),
					model: true,
					items: [
						{ text: this.$vuetify.lang.t('$vuetify.front.messages.items'), path: '/messages', module: 'employee.list_messages' },
						{ text: this.$vuetify.lang.t('$vuetify.front.documents.items'), path: '/documents', module: 'employee.list_documents' },
					],
				},
				{
					module: 'users',
					icon: 'mdi-contacts',
					text: this.$vuetify.lang.t('$vuetify.front.users'),
					model: true,
					items: [
						{ text: 'Lista', path: '/users', module: 'users.list' },
						{ text: 'Task', path: '/tasks', module: 'users.tasks' },
						// { text: this.$vuetify.lang.t('$vuetify.front.permissions'), path: '/permissions', module: 'users.permissions' },
						{ text: this.$vuetify.lang.t('$vuetify.front.permissionsByRole'), path: '/setting/permissions', module: 'settings.permissions' },
						{ text: this.$vuetify.lang.t('$vuetify.front.permissionsByProfile'), path: '/setting/permissions-by-profile', module: 'settings.permissionsByProfile' },
					],
				},

				{
					module: 'settings',
					icon: 'mdi-cog-outline',
					model: true,
					text: this.$vuetify.lang.t('$vuetify.front.setting'),
					items: [
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.store'), path: '/setting/store', module: 'settings.store' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.language'), path: '/setting/language', module: 'settings.language' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.framework'), path: '/setting/framework', module: 'settings.framework' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.finance'), path: '/setting/finance', module: 'settings.finance' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.marketplace'), path: '/setting/marketplace', module: 'settings.marketplace' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.stats'), path: '/setting/stats', module: 'settings.stats' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.seo'), path: '/setting/seo', module: 'settings.seo' },
						{ text: 'Pubblicità', path: '/setting/ads', module: 'settings.seo' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.couriers'), path: '/setting/listcouries', module: 'settings.couriers' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.packagings'), path: '/setting/packaging', module: 'settings.packaging' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.api_payments'), path: '/setting/api-payments', module: 'settings.api_payments' },
						/*{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.payments'), path: '/setting/payments', module: 'settings.payments' },*/
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.currencies'), path: '/setting/currencies', module: 'settings.currencies' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.vat'), path: '/setting/vat', module: 'settings.vat' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.unit'), path: '/setting/unit', module: 'settings.unit' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.thumbnail'), path: '/setting/thumbnail', module: 'settings.thumbnail' },
						{ text: 'Storage', path: '/setting/storage', module: 'settings.thumbnail' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.listing'), path: '/setting/listing', module: 'settings.listing' },
						{ text: this.$vuetify.lang.t('$vuetify.front.items.items'), path: '/setting/products', module: 'settings.products' },
						{ text: this.$vuetify.lang.t('$vuetify.front.items.additionalTab'), path: '/setting/additional-tab', module: 'settings.products' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.orders'), path: '/setting/status-order', module: 'settings.status_order' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.smtpEmail'), path: '/setting/smtp-email', module: 'settings.smtp_email' },
						{ text: 'AI / Social', path: '/setting/ai-social', module: 'settings.ai-social' },
						{ text: this.$vuetify.lang.t('$vuetify.front.subsetting.communication'), path: '/setting/communication', module: 'settings.communication' },
						{ text: 'Notifiche Push', path: '/setting/notifications', module: 'settings.communication' },
					],
				},
				{
					module: 'manage',
					icon: 'mdi-power-settings',
					text: 'Gestione',
					model: true,
					items: [
						{ text: 'Profili', path: '/manage/profiles', module: 'manage' },
						{ text: 'Affiliati', path: '/manage/affiliates', module: 'manage' },
					{ text: 'Pagamenti', path: '/manage/payments', module: 'manage' },
					{ text: 'Audit', path: '/manage/audit', module: 'manage' },
					{ text: 'Salute del server', path: '/manage/server-health', module: 'manage' },
					{ text: 'Cestino ordini', path: '/trash/orders', module: 'manage' },
					{ text: 'Cestino prodotti', path: '/trash/items', module: 'manage' },
						{ text: 'Integrazioni', path: '/manage/integrations', module: 'manage' },
						{ text: 'Slide promo', path: '/manage/promo-slides', module: 'manage' },
						{ text: 'Documentatione', path: '/manage/documentations', module: 'manage' },
						{ text: 'Demo', path: '/manage/demo', module: 'manage' },
					],
				},
			],
			// il merchant a commissione paga una percentuale sul venduto, non i singoli moduli:
			// il gestionale gli si apre tutto, senza dipendere da `Profile.modules` (vedi checkPermissions)
			commission: false,
		};
	},
	computed: {
		...mapGetters({
			getDrawer: 'settings/getDrawer',
			getDrawerFilter: 'settings/getDrawerFilter',
			getPermissions: 'profile/getPermissions',
			getName: 'profile/getName',
			getProfile: 'profile/getProfile',
			getRole: 'profile/getRole',
			getRollback: 'profile/getRollback',
			isAdminSession: 'profile/isAdminSession',
			getLicenseExpired: 'profile/getLicenseExpired',
			getUrl: 'settings/getUrl',
			getToken: 'profile/getToken',
			getUsers: 'users/getUsers',
			getSettings: 'settings/getSetting',
			getServices: 'services/getServices',
			getVersion: 'settings/getVersion',
			getNodeEnv: 'settings/getNodeEnv',
		}),

		navState: {
			get: function () {
				return this.getDrawer;
			},
			set: function () {
				return this.getDrawer;
			},
		},
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
			setSetting: 'settings/setSetting',
		}),
		...mapActions({
			fetchPermissions: 'profile/fetchPermissions',
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',
			fetchServiceactive: 'services/getServiceFetchActive',
			rollbackLogin: 'profile/rollbackLogin',
		}),
		...mapActions({
			setLogout: 'profile/logout',
		}),
		async logout() {
			await this.setLogout();
			await this.setSetting({});
			this.$router.push('/login');
		},
		checkPermissions(module) {
			// 'manage' resta fuori dal bypass: e' l'area SuperAdmin da cui si amministrano TUTTI i
			// merchant, e le sue API rispondono comunque 403 a chi non ha role 0
			if (this.commission && !module.startsWith('manage')) {
				return true;
			}
			return this.getPermissions.modules.includes(module) && this.getPermissions.permissions.includes(module);
		},
		// "Ritorna ad ...": torna alla sessione admin da cui si e' fatto "Loggati come"
		async executeRollback() {
			const dataresponse = await this.rollbackLogin();
			if (dataresponse.status === 201) {
				window.location = '/';
			}
		},
		getSortedItems(items) {
			return items.map(module => {
				return {
					...module,
					items: module.keepOrder ? module.items : module.items.sort((a, b) => a.text.localeCompare(b.text)),
				};
			});
		},
	},
	async mounted() {
		await this.fetchPermissions({});
		let promises = [];
		promises.push(this.fetchSettings());
		promises.push(this.fetchServiceactive(['fattureInCloud', 'aruba', 'ebay','website', 'mws', 'imap', 'aiassistent', 'whatsapp', 'firebase_push', 'googleAnalytics']));
		const result = await Promise.all(promises);

		const status = result[1];
		const setting = result[0];

		// `billingType` di root e non `finance.billingType`: finance e' select:false e al BO non arriva
		this.commission = setting?.billingType === 'commission';

		// il Sito Ecommerce resta legato al servizio anche per il merchant a commissione: senza il
		// nostro framework quelle pagine non hanno dati. Il nome del service e' parte della condizione
		// perche' anche shopify/woocommerce sono type 'framework'
		const website = status.find(el => {
			return el.service === 'website' && el.type === 'framework' && el.active === true;
		});
		if (website) {
			this.items.find(el => el.module === 'ecommerce').model = true;
		}
		const postOrder = this.items.find(el => {
			return el.module === 'post-order';
		});

		const preOrder = this.items.find(el => {
			return el.module === 'pre-order';
		});

		const ecommerce = this.items.find(el => {
			return el.module === 'ecommerce';
		});

		const imap = status.find(el => {
			return el.service === 'imap';
		});

		if (this.commission || (imap?.service && imap.active)) {
			postOrder.items.push({ text: 'Comunicazioni', path: '/communications', module: 'post-order.imap' });
		}

		const fattureincloudService = status.find(el => {
			return el.service === 'fattureInCloud';
		});

		// le integrazioni esterne (fatturazione, marketplace) seguono il servizio anche per il merchant
		// a commissione: senza credenziali attive quelle pagine non hanno niente da mostrare
		const fattureincloudActive = fattureincloudService?.active === true;

		if (fattureincloudActive) {
			postOrder.items.push({ text: 'Fattureincloud', path: '/fattureincloud', module: 'post-order.fattureincloud' });
		}

		// Aruba Fatturazione Elettronica: solo per chi ha il servizio attivo (in Finance ne resta acceso uno solo)
		const arubaService = status.find(el => {
			return el.service === 'aruba';
		});

		if (arubaService?.active) {
			postOrder.items.push({ text: 'Aruba', path: '/aruba', module: 'post-order.aruba' });
		}

		const googleAnalyticsService = status.find(el => {
			return el.service === 'googleAnalytics';
		});

		if (googleAnalyticsService?.service && googleAnalyticsService.active) {
			postOrder.items.push({ text: 'Analytics', path: '/analytics', module: 'post-order.stats' });
		}

		const aiassistentService = status.find(el => {
			return el.service === 'aiassistent';
		});

		if (this.commission || (aiassistentService?.service && aiassistentService.active)) {
			ecommerce.items.push({ text: 'Assistente Virtuale', path: '/assistants', module: 'ecommerce.aiassistant' });
		}

		const whatsappService = status.find(el => {
			return el.service === 'whatsapp';
		});

		if (this.commission || (whatsappService?.service && whatsappService.active)) {
			ecommerce.items.push({ text: 'Whatsapp', path: '/whatsapp', module: 'ecommerce.whatsapp' });
		}

		const firebasePushService = status.find(el => {
			return el.service === 'firebase_push';
		});

		if (this.commission || (firebasePushService?.service && firebasePushService.active)) {
			ecommerce.items.push({ text: 'Invio Notifiche Push', path: '/ecommerce/push-notifications', module: 'ecommerce' });
		}

		if (this.commission || (setting?.frontend?.enableCartEnd && setting?.frontend?.enableCartEnd === true)) {
			ecommerce.items.push({ text: this.$vuetify.lang.t('$vuetify.front.ecommerce.cartend'), path: '/ecommerce/cartend', module: 'ecommerce.cartend' });
		}
		const amazon = status.find(el => {
			return el.service === 'mws';
		});
		const ebay = status.find(el => {
			return el.service === 'ebay';
		});

		if (amazon?.active === true) {
			preOrder.items.push({ text: 'Amazon', path: '/amazon', module: 'pre-order.amazon' });
		}
		if (ebay?.active === true) {
			preOrder.items.push({ text: 'Ebay', path: '/ebay', module: 'pre-order.ebay' });
		}
		if (fattureincloudActive) {
			preOrder.items.push({ text: 'Fattureincloud Ordini', path: '/fattureincloudorder', module: 'pre-order.fattureincloudorder' });
		}

		if (result[0]?.riarrange === true) {
			preOrder.items.push({ text: 'Riordino', path: '/riordino', module: 'pre-order.riordino' });
		}
		//console.log(this.items);
		this.items.map(module => {
			// manage e i gruppi con un ordine voluto (es. Report) restano come sono scritti
			if (module.module === 'manage' || module.keepOrder) {
				return module;
			}
			return {
				...module,
				items: module.items.sort((a, b) => a.text.localeCompare(b.text)),
			};
		});
	},
};
</script>
